// Configuration des colonnes pour l'Historique
export const ALL_COLUMNS = [
  {
    field: 'timestamp',
    header: 'Horodatage',
    defaultVisible: true,
    sortable: true,
    style: { minWidth: '200px' },
    headerStyle: { textAlign: 'left' }
  },
  {
    field: 'temperature',
    header: 'Température (°C)',
    defaultVisible: true,
    sortable: true,
    style: { minWidth: '150px' },
    headerStyle: { textAlign: 'center' }
  },
  {
    field: 'humidity',
    header: 'Humidité (%)',
    defaultVisible: true,
    sortable: true,
    style: { minWidth: '150px' },
    headerStyle: { textAlign: 'center' }
  },
  {
    field: 'porte1Ouvert',
    header: 'Porte Entrée',
    defaultVisible: false,
    sortable: false,
    style: { minWidth: '120px' },
    headerStyle: { textAlign: 'center' }
  },
  {
    field: 'porte2Ouvert',
    header: 'Porte Sortie',
    defaultVisible: false,
    sortable: false,
    style: { minWidth: '120px' },
    headerStyle: { textAlign: 'center' }
  },
  {
    field: 'depassements',
    header: 'Dépassements',
    defaultVisible: true,
    sortable: false,
    style: { minWidth: '200px' },
    headerStyle: { textAlign: 'center' }
  }
];

// Clé pour le localStorage
export const HISTORIQUE_COLUMNS_STORAGE_KEY = 'historique_visible_columns';
